import { render, staticRenderFns } from "./SpeechAlert.vue?vue&type=template&id=07ca3926&scoped=true&"
import script from "./SpeechAlert.vue?vue&type=script&lang=js&"
export * from "./SpeechAlert.vue?vue&type=script&lang=js&"
import style0 from "./SpeechAlert.vue?vue&type=style&index=0&id=07ca3926&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ca3926",
  null
  
)

export default component.exports